<ng-template pTemplate="header">
  <span class="text-xl font-bold">{{ question_title }}</span>
</ng-template>

<div>
  <form [formGroup]="frmFilterReplacementHistory">
    <div class="grid">
      <div class="col md:col-4">
        <p-calendar
          [firstDayOfWeek]="1"
          dateFormat="dd/mm/yy"
          formControlName="rangeDates"
          selectionMode="range"
          [readonlyInput]="true"
          styleClass="w-full"
          placeholder="Filtra per data..."
          [showClear]="true"
          appendTo="body"></p-calendar>
      </div>
      <div class="col md:col-4">
        <p-autoComplete
          [suggestions]="suggestedUsers"
          (completeMethod)="filterUsers($event)"
          field="fullName"
          id="id"
          class="flex-grow-1"
          dataKey="id"
          [emptyMessage]="'Nessun risultato trovato'"
          formControlName="related_user"
          [forceSelection]="true"
          [showClear]="true"
          styleClass="w-full"
          placeholder="Filtra per utente..."
          [showClear]="true"></p-autoComplete>
      </div>
      <div class="col md:col-4">
        <p-button
          styleClass="butt w-full"
          icon="pi pi-filter-slash"
          (click)="clearAssetReplacementHistory(dt2, $event)"
          pTooltip="Elimina filtri"
          tooltipPosition="top"></p-button>
      </div>
    </div>
  </form>
  <p-table
    [paginator]="true"
    [value]="asset_replacement_history"
    #dt2
    [rows]="25"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="rowsPerPageOptions"
    [lazy]="true"
    [loading]="loading"
    (onLazyLoad)="loadAssetReplacementHistory($event)"
    [totalRecords]="totalRecordsReplacementsHistory"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Risultati {first} - {last} di {totalRecords} totali">
    <ng-template pTemplate="header">
      <tr class="tHead">
        <th>Data</th>
        <th>Asset da sostituire</th>
        <th>Sostituito da</th>
        <th>Utente</th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-a>
      <tr>
        <td>{{ a.created_on | date: 'dd/MM/yyyy HH:mm' }}</td>
        <td>
          <a
            [routerLink]="['/main/asset/modifica-asset', a.related_asset_management?.id]"
            class="butt p-button p-button-outlined">
            {{ a.related_asset_management?.serial_number ?? '-' }}</a
          >
        </td>
        <td>
          <ng-container *ngIf="a.replacement_for">
            <a
              [routerLink]="['/main/asset/modifica-asset', a.replacement_for?.id]"
              class="butt p-button p-button-outlined">
              {{ a.replacement_for?.serial_number ?? '-' }}</a
            >
          </ng-container>
          <ng-container *ngIf="!a.replacement_for"> - </ng-container>
        </td>
        <td>{{ a.related_user?.name || '-' }} {{ a.related_user?.last_name || '-' }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td
          colspan="4"
          class="text-center py-2">
          Nessun risultato.
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
